import { useWizard } from '@zillow/zrs-rental-applications';
import { Field, Form as ReactFinalForm } from 'react-final-form';
import React, { useCallback } from 'react';
import { Form, VisuallyHidden } from '@zillow/constellation';
import useSetName from '../../../../utils/apis/useSetName';
import { useHistory } from 'react-router-dom';
import { ZTSS_ENTER_YOUR_ADDRESS } from '../../../../constants/paths';
import { LabeledInput } from '../../../../components/LabeledInput/LabeledInput';
import LinkButton from '../../../../components/LinkButton';
import useGetNames from '../../../../utils/apis/useGetNames';
import { getWizardOnSubmit } from '../../../../utils/wizardUtils';
import ListingWizardStep from '../ListingWizardStep';
import { DetailedIconProfile } from '@zillow/constellation';
import { FULLSTORY_EXCLUDE } from '../../../../constants/fullstory';

const INVALID_MSG = 'Please enter a value';

function InternalFormRenderer({ invalid, form, isFetchingNames, id, label }) {
  const { isLoading } = useWizard();
  const renderNextButton = useCallback(
    ({ onRequestNext, buttonProps }) => (
      <LinkButton
        to={ZTSS_ENTER_YOUR_ADDRESS}
        disabled={isLoading || invalid}
        {...buttonProps}
        onClick={(e) => {
          e.preventDefault();
          onRequestNext();
        }}
      >
        Continue
      </LinkButton>
    ),
    [invalid, isLoading],
  );
  const renderPrevButton = useCallback(() => <div />, []);
  return (
    <ListingWizardStep
      id={id}
      label={label}
      onSubmit={getWizardOnSubmit(form)}
      meta={{
        renderNextButton,
        renderPrevButton,
      }}
      isLoading={isFetchingNames}
      icon={<DetailedIconProfile />}
      title="Who's screening applicants?"
      description="Enter the property manager or primary contact for applicants who receive an application."
      render={({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Field
            name="firstName"
            label="First name"
            component={LabeledInput}
            className={FULLSTORY_EXCLUDE}
            validate={(value) => (value?.length > 0 ? null : INVALID_MSG)}
            marginBottom="md"
          />
          <Field
            name="lastName"
            label="Last name"
            component={LabeledInput}
            className={FULLSTORY_EXCLUDE}
            validate={(value) => (value?.length > 0 ? null : INVALID_MSG)}
          />
          <VisuallyHidden as="button" type="submit" id="submit-name-form">
            Submit
          </VisuallyHidden>
        </Form>
      )}
    />
  );
}

export default function EnterYourNameStep({ id, label }) {
  const history = useHistory();
  const { data, isLoading: isFetchingNames } = useGetNames({
    select(responseData) {
      return responseData.data.response.profileInfoDtos[0];
    },
  });
  const { mutateAsync: setName } = useSetName({
    onSuccess() {
      history.push(ZTSS_ENTER_YOUR_ADDRESS, { isFromNameStep: true });
    },
  });
  return (
    <ReactFinalForm
      onSubmit={setName}
      initialValues={{
        firstName: data?.firstName,
        lastName: data?.lastName,
      }}
      component={InternalFormRenderer}
      id={id}
      label={label}
      isFetchingNames={isFetchingNames}
    />
  );
}
